export const constant = {
    GET_SUBSCIPTION_PLANS_IN_PROGRESS: "GET_SUBSCIPTION_PLANS_IN_PROGRESS",
    GET_SUBSCIPTION_PLANS_COMPLETE: "GET_SUBSCIPTION_PLANS_COMPLETE"
  };
  